import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiCheck, FiSearch, FiBarChart2 } from "react-icons/fi";
import "./IntelligenceSection.css";

function RobotIllustration() {
  return (
    <div className="insight-robot-scene" aria-hidden="true">
      <div className="insight-speech">AI turns<br />data into growth!</div>
      <div className="insight-robot">
        <div className="insight-antenna" />
        <div className="insight-robot-head"><div className="insight-robot-face"><i /><i /></div></div>
        <div className="insight-robot-body"><FiCheck /></div>
        <div className="insight-robot-arm insight-robot-arm-left" /><div className="insight-robot-arm insight-robot-arm-right" />
      </div>
      <div className="insight-mini-bars"><FiBarChart2 /></div>
    </div>
  );
}

function ResearchIllustration() {
  return (
    <div className="insight-research-scene" aria-hidden="true">
      <div className="insight-research-note">Find opportunities<br />before your competitors!<span>⤵</span></div>
      <div className="insight-research-dashboard">
        <div className="insight-research-toolbar"><span><FiSearch /> competitor.com</span><b>Research</b></div>
        <div className="insight-research-metrics"><span><strong>92</strong>SEO score</span><span><strong>125K</strong>Traffic</span><span><strong>4.8K</strong>Keywords</span></div>
        <div className="insight-research-chart">
          <svg viewBox="0 0 230 130" fill="none">
            {[20, 50, 80, 110].map(y => <path key={y} d={`M10 ${y}H220`} stroke="#edf2f8" />)}
            <path d="M12 110L48 83L82 65L116 70L154 39L190 24L218 8V115H12Z" fill="#e5f2ff" />
            <path d="M12 110L48 83L82 65L116 70L154 39L190 24L218 8" stroke="#0879ff" strokeWidth="3" />
            {[[48,83],[82,65],[116,70],[154,39],[190,24]].map(([x,y]) => <circle key={x} cx={x} cy={y} r="3" fill="#0879ff" />)}
          </svg>
          <div>{["Keywords", "Backlinks", "Rankings", "Content", "Competitors"].map(label => <span key={label}><FiCheck /> {label}</span>)}</div>
        </div>
        <small>Example insights</small>
      </div>
    </div>
  );
}

const panels = [
  { id: "ai", eyebrow: "AI-POWERED RESULTS", title: <>Smarter Insights with <span>AI</span></>, description: "Let AI analyze your data and give actionable SEO & SMO recommendations to grow faster.", benefits: ["AI-powered analysis", "Content recommendations", "Keyword opportunities", "Competitor insights"], action: "Try AI Analysis Free", path: "/bix-keyword-analyzer", Illustration: RobotIllustration },
  { id: "research", eyebrow: "DEEP RESEARCH", title: <>Understand Your Market Better</>, description: "Explore competitor strategies, keyword trends and industry insights.", benefits: ["Competitor analysis", "Trending keywords", "SERP data & intent", "Market & content gaps"], action: "Start Research", path: "/competitive-research-with-seobix-understand-your-competitors-strategies", Illustration: ResearchIllustration },
];

export default function IntelligenceSection() {
  return (
    <section className="home-section intelligence-section pt-4" aria-label="AI insights and market research">
      <div className="home-content intelligence-grid">
        {panels.map(({ id, eyebrow, title, description, benefits, action, path, Illustration }) => (
          <article className={`intelligence-panel intelligence-panel-${id}`} key={id} aria-labelledby={`intelligence-${id}-heading`}>
            <header><span className="intelligence-eyebrow">{eyebrow}</span><h2 id={`intelligence-${id}-heading`}>{title}</h2><p>{description}</p></header>
            <div className="intelligence-panel-content">
              <div className="intelligence-actions"><ul>{benefits.map(benefit => <li key={benefit}><span><FiCheck aria-hidden="true" /></span>{benefit}</li>)}</ul><Link to={path}>{action}<FiArrowRight aria-hidden="true" /></Link></div>
              <Illustration />
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
